import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { AdminGuardService } from 'src/app/core/services/admin-guard.service';
import { CommandCenterSetupComponent } from './admin-section/command-center-setup/command-center-setup.component';
import { MenuSetupComponent } from './admin-section/command-center-setup/menu-setup/menu-setup.component';
import { TableDataModelListComponent } from './admin-section/command-center-setup/table-data-model-list/table-data-model-list.component';
import { TableDataModelSetupComponent } from './admin-section/command-center-setup/table-data-model-setup/table-data-model-setup.component';
import { DealerAdminDashboardComponent } from './admin-section/dealers/dealer-admin-dashboard/dealer-admin-dashboard.component';
import { SocketMonitorComponent } from './admin-section/socket-monitor/socket-monitor.component';
import { AutomaticEmployeeMessageSingleComponent } from './communication/automatic-employee-messages/automatic-employee-message-single/automatic-employee-message-single.component';
import { AutomaticEmployeeMessagesComponent } from './communication/automatic-employee-messages/automatic-employee-messages.component';
import { EmployeeMessageComponent } from './communication/employee-message/employee-message.component';
import { LogListViewComponent } from './communication/manager-log/log-list-view/log-list-view.component';
import { ContractFinanceSetupComponent } from './contract-finance/contract-finance-setup/contract-finance-setup.component';
import { ContractFinanceComponent } from './contract-finance/contract-finance.component';
import { BatchRecordComponent } from './credit/credit-dashboard/batch-record/batch-record.component';
import { CreditDashboardComponent } from './credit/credit-dashboard/credit-dashboard.component';
import { ProcessingStatusComponent } from './credit/processing-status/processing-status.component';
import { CustomerDashboardComponent } from './customer/customer-dashboard/customer-dashboard.component';
import { CustomerDetailComponent } from './customer/customer-detail/customer-detail.component';
import { CustomerSurveyResultComponent } from './customer/customer-survey/customer-survey-result/customer-survey-result.component';
import { CustomerSurveySetupComponent } from './customer/customer-survey/customer-survey-setup/customer-survey-setup.component';
import { CustomerSurveyComponent } from './customer/customer-survey/customer-survey.component';
import { DashboardV2Component } from './dashboard-v2/dashboard-v2.component';
import { ChecksDashboardComponent } from './dashboard/checks-dashboard/checks-dashboard.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DealersComponent } from './dealers/dealers.component';
import { EmployeeLaborShiftRecordComponent } from './employee-management/employee-scheduling/employee-labor-shift/employee-labor-shift-record/employee-labor-shift-record.component';
import { EmployeeScheduleRecordComponent } from './employee-management/employee-scheduling/employee-schedule-record/employee-schedule-record.component';
import { EmployeeSchedulingComponent } from './employee-management/employee-scheduling/employee-scheduling.component';
import { EmployeeRecordComponent } from './employee-management/employees/employee-record/employee-record.component';
import { EmployeesComponent } from './employee-management/employees/employees.component';
import { TimeAndAttendanceComponent } from './employee-management/time-and-attendance/time-and-attendance.component';
import { TimecardRecordComponent } from './employee-management/time-and-attendance/timecard-record/timecard-record.component';
import { GuestViewComponent } from './guest/guest-view/guest-view.component';
import { LoyaltyEmailTemplateSetupComponent } from './loyalty/loyalty-email-template-setup/loyalty-email-template-setup.component';
import { BlastDetailComponent } from './marketing/blasts/blast-detail/blast-detail.component';
import { BlastsComponent } from './marketing/blasts/blasts.component';
import { GroupsComponent } from './marketing/groups/groups.component';
import { TemplateSetupComponent } from './marketing/templates/template-setup/template-setup.component';
import { TemplatesComponent } from './marketing/templates/templates.component';
import { CanvasRecordSetupComponent } from './menu/canvas-setup/canvas-record-setup/canvas-record-setup.component';
import { CanvasSetupComponent } from './menu/canvas-setup/canvas-setup.component';
import { CanvasComponent } from './menu/canvases/canvas/canvas.component';
import { CanvasesComponent } from './menu/canvases/canvases.component';
import { CustomMenuSetupComponent } from './menu/custom-menu-setup/custom-menu-setup.component';
import { MenuItemSetupComponent } from './menu/menu-item-setup/menu-item-setup.component';
import { PriceLevelSetupComponent } from './menu/price-level-setup/price-level-setup.component';
import { ApplicationSingleViewComponent } from './payments/application-status/application-single-view/application-single-view.component';
import { ApplicationStatusComponent } from './payments/application-status/application-status.component';
import { DevicesComponent } from './payments/devices/devices.component';
import { EGiftTransactionsComponent } from './reports/e-gift-transactions/e-gift-transactions.component';
import { ReportsComponent } from './reports/reports/reports.component';
import { AliasUrlSetupComponent } from './setup/alias-url-setup/alias-url-setup.component';
import { GeneralSetupComponent } from './setup/general-setup/general-setup.component';
import { GiftCardAppleWalletSetupComponent } from './setup/gift-card-setup/gift-card-apple-wallet-setup/gift-card-apple-wallet-setup.component';
import { GiftCardSetupComponent } from './setup/gift-card-setup/gift-card-setup.component';
import { GiftCardViewComponent } from './setup/gift-card-setup/gift-card-view/gift-card-view.component';
import { IntegrationSetupComponent } from './setup/integration-setup/integration-setup.component';
import { ItemTagSetupComponent } from './setup/item-tag-setup/item-tag-setup.component';
import { LinkKeySetupComponent } from './setup/link-key-setup/link-key-setup.component';
import { LinkQrExportComponent } from './setup/link-key-setup/link-qr-export/link-qr-export.component';
import { ConnectorSetupComponent } from './setup/link/connector-setup/connector-setup.component';
import { DataImportHistoryComponent } from './setup/link/data-import-history/data-import-history.component';
import { KitchenSetupComponent } from './setup/link/kitchen-setup/kitchen-setup.component';
import { OnSetupComponent } from './setup/link/on-setup/on-setup.component';
import { MobilePaySetupComponent } from './setup/mobile-pay-setup/mobile-pay-setup.component';
import { OrderTypeSetupComponent } from './setup/order-type-setup/order-type-setup.component';
import { PaymentLoyaltySetupComponent } from './setup/payment-loyalty-setup/payment-loyalty-setup.component';
import { PromoCodeSetupComponent } from './setup/promo-code-setup/promo-code-setup.component';
import { SnapshotSetupComponent } from './setup/snapshot-setup/snapshot-setup.component';
import { StyleSetupComponent } from './setup/style-setup/style-setup.component';
import { TimeRangesComponent } from './setup/time-ranges/time-ranges.component';
import { VenueAdministrationComponent } from './setup/venue-administration/venue-administration.component';
import { VenueGroupSetupComponent } from './setup/venue-group-setup/venue-group-setup.component';
import { WebhookSetupComponent } from './setup/webhook-setup/webhook-setup.component';
import { SubscriptionSetupComponent } from './subscriptions/subscription-setup/subscription-setup.component';
import { UserSetupComponent } from './user/user-setup/user-setup.component';

const routes: Routes = [
	{
		path: '',
		component: AppMainComponent,
		children: [
			{ path: 'dashboardv2', component: DashboardV2Component },
			{ path: 'dashboard', component: DashboardComponent },
			{
				path: 'dealers',
				children: [
					{
						path: 'dashboard',
						component: DealersComponent,
					},
				],
			},
			{
				path: 'credit',
				children: [
					{
						path: 'processing',
						children: [
							{
								path: 'status',
								component: ProcessingStatusComponent,
							},
						],
					},
					{
						path: 'dashboard',
						component: CreditDashboardComponent,
					},
					{
						path: 'batch/:batchNumber',
						component: BatchRecordComponent,
					},
				],
			},
			{
				path: 'customers',
				children: [
					{
						path: 'dashboard',
						component: CustomerDashboardComponent,
					},
					{
						path: 'survey',
						component: CustomerSurveyComponent,
					},
					{
						path: 'survey/:surveyKey',
						component: CustomerSurveySetupComponent,
					},
					{
						path: 'survey/:surveyKey/:responseKey',
						component: CustomerSurveyResultComponent,
					},
					{
						path: ':customerKey',
						component: CustomerDetailComponent,
					},
				],
			},
			{ path: 'checks', component: ChecksDashboardComponent },
			{
				path: 'employees',
				children: [
					{
						path: 'list',
						component: EmployeesComponent,
					},
					{
						path: 'schedules',
						component: EmployeeSchedulingComponent,
					},
					{
						path: 'schedules/shifts/:shiftKey',
						component: EmployeeLaborShiftRecordComponent,
					},
					{
						path: 'timecards',
						component: TimeAndAttendanceComponent,
					},
					{
						path: 'timecards/:timecardRecord',
						component: TimecardRecordComponent,
					},
					{
						path: 'schedules/:scheduleExternalId',
						component: EmployeeScheduleRecordComponent,
					},
					{
						path: ':employeeId',
						component: EmployeeRecordComponent,
					},
				],
			},
			{
				path: 'menu',
				children: [
					{ path: 'canvases', component: CanvasesComponent },
					{ path: 'canvases/:canvasKey', component: CanvasComponent },
					{ path: 'canvas', component: CanvasSetupComponent },
					{ path: 'canvas/:canvasKey', component: CanvasRecordSetupComponent },
					{ path: 'item', component: MenuItemSetupComponent },
					{ path: 'pricelevel', component: PriceLevelSetupComponent },
					{ path: 'custommenu', component: CustomMenuSetupComponent },
				],
			},
			{
				path: 'finance',
				children: [
					{ path: 'invoices', component: ContractFinanceComponent },
					{ path: 'setup', component: ContractFinanceSetupComponent },
				],
			},
			{
				path: 'gift',
				children: [
					{ path: 'setup', component: GiftCardSetupComponent },
					{ path: 'cards', component: GiftCardViewComponent },
				],
			},
			{
				path: 'guest',
				children: [{ path: 'view', component: GuestViewComponent }],
			},
			{
				path: 'communication',
				children: [
					{
						path: 'log',
						component: LogListViewComponent,
					},
					{
						path: 'message',
						component: EmployeeMessageComponent,
					},
					{
						path: 'automessages',
						component: AutomaticEmployeeMessagesComponent,
					},
					{
						path: 'automessages/:messageSk',
						component: AutomaticEmployeeMessageSingleComponent,
					},
				],
			},
			{
				path: 'loyalty',
				children: [
					{
						path: 'emailtemplate',
						component: LoyaltyEmailTemplateSetupComponent,
					},
				],
			},
			{
				path: 'marketing',
				children: [
					{
						path: 'blasts',
						component: BlastsComponent,
					},
					{
						path: 'blasts/:blastKey',
						component: BlastDetailComponent,
					},
					{
						path: 'groups',
						component: GroupsComponent,
					},
					{
						path: 'templates/:templateKey',
						component: TemplateSetupComponent,
					},
					{
						path: 'templates',
						component: TemplatesComponent,
					},
				],
			},
			{
				path: 'payments',
				children: [
					{
						path: 'focuspay',
						children: [
							{
								path: 'applications',
								component: ApplicationStatusComponent,
							},
							{
								path: 'applications/:applicationKey',
								component: ApplicationSingleViewComponent,
							},
							{
								path: 'devices',
								component: DevicesComponent,
							},
						],
					},
				],
			},
			{
				path: 'reports',
				component: ReportsComponent,
			},
			{
				path: 'setup',
				children: [
					{ path: 'general', component: GeneralSetupComponent },
					{ path: 'integration', component: IntegrationSetupComponent },
					{ path: 'itemtag', component: ItemTagSetupComponent },
					{ path: 'linkkey', component: LinkKeySetupComponent },
					{ path: 'linkkey/qr', component: LinkQrExportComponent },
					{ path: 'mobilepay', component: MobilePaySetupComponent },
					{ path: 'giftCards', component: GiftCardSetupComponent },
					{ path: 'ordertype', component: OrderTypeSetupComponent },
					{ path: 'paymentloyalty', component: PaymentLoyaltySetupComponent },
					{ path: 'snapshot', component: SnapshotSetupComponent },
					{ path: 'style', component: StyleSetupComponent },
					{ path: 'timeranges', component: TimeRangesComponent },
					{ path: 'aliasurl', component: AliasUrlSetupComponent },
					{ path: 'promocode', component: PromoCodeSetupComponent },
					{
						path: 'user',
						component: UserSetupComponent,
					},
					{
						path: 'venue',
						component: VenueAdministrationComponent,
					},
					{
						path: 'venuegroup',
						component: VenueGroupSetupComponent,
					},
					{
						path: 'webhook',
						component: WebhookSetupComponent,
					},
					{
						path: 'gift',
						component: GiftCardSetupComponent,
					},
					{
						path: 'gift/wallet',
						component: GiftCardAppleWalletSetupComponent,
					},
					{
						path: 'gift/transactions',
						component: EGiftTransactionsComponent,
					},
					{
						path: 'link',
						children: [
							{
								path: 'connector',
								component: ConnectorSetupComponent,
							},
							{
								path: 'dataimport',
								component: DataImportHistoryComponent,
							},
							{
								path: 'kitchen',
								component: KitchenSetupComponent,
							},
							{
								path: 'on',
								component: OnSetupComponent,
							},
						],
					},
				],
			},
			{
				path: 'subscriptions',
				component: SubscriptionSetupComponent,
			},
			{
				path: 'admin',
				canActivate: [AdminGuardService],
				children: [
					{ path: 'system', component: CommandCenterSetupComponent },
					{
						path: 'dealeradmin',
						component: DealerAdminDashboardComponent,
					},
					{
						path: 'tablesetup',
						component: TableDataModelListComponent,
					},
					{
						path: 'tablesetup/:tableModel',
						component: TableDataModelSetupComponent,
					},
					{
						path: 'menusetup',
						component: MenuSetupComponent,
					},
					{
						path: 'socketmonitor',
						component: SocketMonitorComponent,
					},
				],
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class CommandCenterRoutingModule {}
